// extracted by mini-css-extract-plugin
export default {"brandButton":"OMB_brandButton__V8Uhc","getStartedButton":"OMB_getStartedButton__L6wD+","main":"OMB_main__tSS49"};